// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app{height:100%}", "",{"version":3,"sources":["webpack://./src/App.vue?vue&type=style&index=0&id=d5347bf4&prod&lang=less","webpack://./src/App.vue"],"names":[],"mappings":"AACA,KACE,WCAF","sourcesContent":["\n#app {\n  height: 100%;\n}\n","#app {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
